// extracted by mini-css-extract-plugin
export default {"JobworksPaymentsPage":"JobworksPaymentsPage_JobworksPaymentsPage__w1cJM"};